import { useContext } from "react";
import ToggleSidebarContext from "./ToggleSidebarContext";

export default function CollapseSidebar() {
  const { setCollapseSidebar } = useContext(ToggleSidebarContext);
  return (
    <div className="h-full flex items-center justify-center ml-[-1.5rem] z-10">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="size-6 cursor-pointer"
        onClick={() => setCollapseSidebar(true)}
      >
        <circle cx="8" cy="8" r="8" fill="white" />
        <path
          d="M5.18875 8.2125C5.0725 8.09625 5.0725 7.905 5.18875 7.78875L8.78875 4.18875C8.905 4.0725 9.09625 4.0725 9.2125 4.18875C9.32875 4.305 9.32875 4.49625 9.2125 4.6125L5.82437 8.00062L9.2125 11.3888C9.32875 11.505 9.32875 11.6962 9.2125 11.8125C9.09625 11.9287 8.905 11.9287 8.78875 11.8125L5.18875 8.2125Z"
          fill="#94A3B8"
        />
      </svg>
    </div>
  );
}
